/******Partenaires******/

/*PAGE*/
export default function Partenaires(data) {
  //append arrays
  let array0 = data.data[0];
  let array1 = data.data[1];
  let array2 = data.data[2];

  //Alphabetical sorting for array 1 & 2
  array1.sort((a, b) => a.name.localeCompare(b.name));
  array2.sort((a, b) => a.name.localeCompare(b.name));

  //Dynamic display of cards according to selected section / url
  function displayCards2(R, i) {
    if (R.link != undefined && R.link != "" && R.link != null) {
      return (
        <a className="cardLink" key={R.name + i} href={R.link} target="_blank">
          <p className="cardName">{R.name}</p>

          <div className="cardImg">
            <img
              fetchpriority="high"
              src={"/img/part/" + R.img + ".webp"}
              alt={"Image d'illustration pour :" + " " + R.name}
            />
          </div>
        </a>
      );
    } else {
      return (
        <div className="realCard" key={R.name + i}>
          <p className="cardName">{R.name}</p>
          <div className="cardImg">
            <img
              fetchpriority="high"
              src={"/img/part/" + R.img + ".webp"}
              alt={"Image d'illustration pour :" + " " + R.name}
            />
          </div>
        </div>
      );
    }
  }

  /*DOM*/
  return (
    <div className="homepage realisations partenaires">
      <h1>Nos partenaires</h1>
      <h2 className="introH2">
        Le projet "Université Numérique Avancée" est porté par Nîmes Université.
        Il mobilise l'expertise et les compétences de nombreux
        partenaires locaux et nationaux, avec pour objectif de fédérer les
        acteurs de l'éducation, de la formation, et des technologies numériques.
        <br />
        <br />
        Ancré dans une dynamique territoriale, le projet travaille en lien
        étroit avec les collectivités locales pour renforcer l'impact de
        l'Université sur l'ensemble du territoire. En tant que démonstrateur
        national de l'enseignement supérieur (DemoES), "Université Numérique
        Avancée" collabore également avec d'autres initiatives en France.
        <br />
        <br />
        Fortement engagé dans la transformation numérique, le projet développe
        des partenariats stratégiques avec des entreprises Edtech pour
        co-concevoir des solutions pédagogiques innovantes, au service de
        l'apprentissage et de l'enseignement.
      </h2>
      <div className="mainText">
        <div className="mainLeft mainLeftNew">
          <h2>Établissements observateurs</h2>
        </div>
      </div>
      <div className="realWrapper">
        {array0.map((R, i) => displayCards2(R, i))}
      </div>
      <div className="mainText">
        <div className="mainLeft mainLeftNew">
          <h2>Partenaires technologiques pour l'enseignement</h2>
        </div>
      </div>
      <div className="realWrapper">
        {array1.map((R, i) => displayCards2(R, i))}
      </div>{" "}
      <div className="mainText">
        <div className="mainLeft mainLeftNew">
          <h2>Partenaires technologiques</h2>
        </div>
      </div>
      <div className="realWrapper">
        {array2.map((R, i) => displayCards2(R, i))}
      </div>
    </div>
  );
}
